import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import { Add, Edit, GetAll, Remove } from '../../../configurations/crud/doctorsFastNoteCurd'
import { MdDelete, MdErrorOutline, MdAdd } from 'react-icons/md'
import { useToast } from '../../controls/Toast/ToastService'
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5'
import LoadingContainer from '../../controls/LoadingContainer'
import Empty from '../../controls/Empty'
import { RiEditBoxFill } from 'react-icons/ri'
import PagingEmpty from '../../controls/PagingEmpty'
import { CiLocationArrow1 } from 'react-icons/ci'
import DeleteFastNoteModal from './DeleteFastNoteModal'
import AddFastNoteModal from './AddFastNoteModal'
import EditFastNoteModal from './EditFastNoteModal'
import Card from '../../controls/Card'
import useGlobalLoader from '../../../configurations/useGlobalLoader'


export default function ViewFastNotes() {
  const { start, end } = useGlobalLoader()
  const [FastNotesData, setFastNotesData] = useState([])
  const [loding, setLoding] = useState(false)
  const toast = useToast()
  const [lodingCrud, setLodingCrud] = useState(false)
  const [isOpenAdd, setIsOpenAdd] = useState(false)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [isOpenDelete, setIsOpenDelete] = useState(false)

  const [editData, setEditData] = useState({
    id: 0,
    note: "",
    priority: "0",
  })

  useEffect(() => {
    GetFastNotes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const GetFastNotes = () => {
    setLoding(true)
    start()
    GetAll().then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setFastNotesData(mdata.data)
      } else {
        setFastNotesData([])
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setFastNotesData([])
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const AddFastNote = (param, setValues) => {
    setLodingCrud(true)
    start()
    Add(param).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setValues({
          note: "",
          priority: "0",
        })
        setIsOpenAdd(false)
        GetFastNotes()
        toast.open("FastNote added successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const EditFastNote = (param, setValues) => {
    setLodingCrud(true)
    start()
    Edit(param).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setValues({
          id: 0,
          note: "",
          priority: "0",
        })
        setIsOpenEdit(false)
        GetFastNotes()
        toast.open("FastNote updated successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const DeleteFastNote = (id) => {
    setLodingCrud(true)
    start()
    Remove(id).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setIsOpenDelete(false)
        GetFastNotes()

        toast.open("FastNotes deleted successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  // edit + delete actions (shared by table + cards)
  const renderActions = (item) => (
    <>
      <button
        type="button"
        title="Edit"
        onClick={() => { setEditData(item); setIsOpenEdit(!isOpenEdit) }}
        className="grid h-9 w-9 place-items-center rounded-lg text-brand-600 transition hover:bg-brand-50 active:scale-95"
      >
        <RiEditBoxFill className="text-xl" />
      </button>
      <button
        type="button"
        title="Delete"
        onClick={() => { setEditData(item); setIsOpenDelete(!isOpenDelete) }}
        className="grid h-9 w-9 place-items-center rounded-lg text-red-600 transition hover:bg-red-50 active:scale-95"
      >
        <MdDelete className="text-xl" />
      </button>
    </>
  )

  return (
    <Container title={"Manage Fast Notes"}>
      <div className="w-full px-2 sm:px-4">
        <Card title={"Manage Fast Notes"} isBorder={true}>

          {/* New */}
          <div className="mb-3">
            <button
              onClick={() => setIsOpenAdd(!isOpenAdd)}
              className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-b from-brand-400 to-brand-500 px-4 py-2 text-sm font-semibold text-white shadow-brand transition hover:brightness-105 active:scale-95"
            >
              <MdAdd className="text-lg" /> New Note
            </button>
          </div>

          <PagingEmpty count={FastNotesData.length}>
            {!loding ? (
              FastNotesData.length > 0 ? (
                <>
                  {/* desktop table */}
                  <div className="hidden overflow-x-auto rounded-xl ring-1 ring-gray-100 sm:block">
                    <table className="w-full border-collapse text-left text-sm text-gray-500">
                      <thead>
                        <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                          <th scope="col" className="px-5 py-3 font-semibold">#</th>
                          <th scope="col" className="px-5 py-3 font-semibold">Note</th>
                          <th scope="col" className="px-5 py-3 font-semibold">Priority</th>
                          <th scope="col" className="px-5 py-3 text-right font-semibold">Action</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                        {FastNotesData.map((item, index) => (
                          <tr key={index} className="bg-white hover:bg-gray-50">
                            <td className="px-5 py-2.5 text-gray-500">{index + 1}</td>
                            <td className="px-5 py-2.5 font-medium text-gray-800">{item.note}</td>
                            <td className="px-5 py-2.5">
                              <span className="rounded-md bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700">{item.priority}</span>
                            </td>
                            <td className="px-5 py-2.5">
                              <div className="flex items-center justify-end gap-1">{renderActions(item)}</div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* mobile cards */}
                  <div className="space-y-2 sm:hidden">
                    {FastNotesData.map((item, index) => (
                      <div key={index} className="rounded-xl border border-gray-100 bg-white p-3">
                        <div className="flex items-start justify-between gap-2">
                          <div className="min-w-0">
                            <div className="text-xs text-gray-400">
                              #{index + 1} · Priority <span className="font-semibold text-brand-700">{item.priority}</span>
                            </div>
                            <div className="mt-0.5 font-medium text-gray-800">{item.note}</div>
                          </div>
                          <div className="flex shrink-0 items-center gap-1">{renderActions(item)}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <Empty>No Items Found.</Empty>
              )
            ) : (
              <LoadingContainer />
            )}
          </PagingEmpty>

          {/* modals */}
          <EditFastNoteModal isOpen={isOpenEdit} setIsOpen={setIsOpenEdit} editData={editData} EditFastNote={EditFastNote} loding={lodingCrud} />
          <AddFastNoteModal AddFastNote={AddFastNote} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} />
          <DeleteFastNoteModal DeleteFastNote={DeleteFastNote} isOpen={isOpenDelete} setIsOpen={setIsOpenDelete} loding={lodingCrud} id={editData.id} name={editData.note} />
        </Card>
      </div>
    </Container>
  )
}